'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var MPPFooter = function (_React$Component) {
  _inherits(MPPFooter, _React$Component);

  function MPPFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MPPFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MPPFooter.__proto__ || Object.getPrototypeOf(MPPFooter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showImages: false
    }, _this.handleScroll = function () {
      window.removeEventListener('scroll', _this.handleScroll);
      _this.enableImages();
    }, _this.renderFlag = function (flag) {
      if (flag && !_this.props.loggedIn && _this.state.showImages) {
        var _this$props = _this.props,
            flagHref = _this$props.flagHref,
            localeCountry = _this$props.localeCountry;

        var flagStyle = {
          backgroundImage: 'url(https://www.paypalobjects.com/webstatic/mktg/icons/sprite_countries_flag4.png)'
        };
        return _react2.default.createElement(
          'a',
          {
            href: flagHref,
            'aria-label': flag.text,
            title: flag.text,
            className: (0, _classnames2.default)('country', 'lazy-load-flag', localeCountry),
            'data-pa-click': 'FooterFlag-Link-' + flag.text,
            style: flagStyle
          },
          flag.text
        );
      }
      return null;
    }, _this.renderLinks = function (links) {
      if (links && links.list) {
        return links.list.map(function (elem) {
          return _react2.default.createElement(
            'li',
            { key: elem.text, id: elem.id ? elem.id : null },
            _react2.default.createElement(
              'a',
              {
                href: elem.href,
                target: elem.target ? elem.target : null,
                'data-pa-click': 'Footer-Link-' + elem.text
              },
              elem.text
            )
          );
        });
      }
      return null;
    }, _this.renderCopyRight = function (copyRightReservedText) {
      var copyRight = '&copy; 1999&ndash;' + new Date().getFullYear() + ' ';
      return _react2.default.createElement(
        'li',
        { className: 'footer-copyright' },
        htmlToReactParser.parse(copyRight + copyRightReservedText)
      );
    }, _this.renderFooterNotes = function (footerNotes) {
      if (footerNotes) {
        return _react2.default.createElement(
          'p',
          { className: 'footer-notes' },
          htmlToReactParser.parse(footerNotes.text)
        );
      }
      return null;
    }, _this.renderLogo = function (imageUrl, logoClass) {
      var logoStyle = {
        backgroundImage: 'url(' + imageUrl + ')'
      };
      return _react2.default.createElement('div', { className: logoClass + '-logo', style: logoStyle });
    }, _this.renderLocales = function (locales) {
      if (locales && !_this.props.loggedIn) {
        return locales.map(function (elem, idx) {
          return _react2.default.createElement(
            'a',
            {
              key: elem.text,
              className: 'language',
              href: elem.href,
              'data-pa-click': 'FooterLocales' + idx + '-Link-' + elem.text
            },
            elem.text
          );
        });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MPPFooter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }

    // Display country flag


    // render the copyright dates


    // Footer notes


    // footer note logo


    // Display country locales supported by MPP

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          rtl = _props.rtl;
      var _content$country = content.country,
          flag = _content$country.flag,
          locales = _content$country.locales;
      var mainLinks = content.mainLinks,
          secondaryLogo = content.secondaryLogo,
          secondaryLinks = content.secondaryLinks,
          tertiaryLinks = content.tertiaryLinks,
          footNoteLogo = content.footNoteLogo;


      var copyRightReservedText = content.copyRight && content.copyRight.reservedText || '';
      var footerNotes = content.footerNotes || '';
      var showImages = this.state.showImages;

      var footerClassNames = (0, _classnames2.default)('global-footer', {
        'global-footer--rtl': rtl
      });

      return _react2.default.createElement(
        'footer',
        {
          'data-building-block': 'organism',
          className: footerClassNames,
          id: 'footer',
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              _react2.default.createElement(
                'ul',
                { className: 'footer-main' },
                _react2.default.createElement(
                  'li',
                  { className: 'country-selector' },
                  this.renderLocales(locales),
                  this.renderFlag(flag)
                )
              ),
              _react2.default.createElement(
                'ul',
                { className: 'footer-main' },
                this.renderLinks(mainLinks)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              _react2.default.createElement('hr', { className: 'hidden-lg-down' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              showImages && secondaryLogo && secondaryLogo.imageUrl && this.renderLogo(secondaryLogo.imageUrl, 'secondary'),
              secondaryLinks && _react2.default.createElement(
                'ul',
                { className: 'footer-secondary footer-corplinks' },
                this.renderLinks(secondaryLinks)
              ),
              _react2.default.createElement(
                'ul',
                { className: 'footer-tertiary copyright-section' },
                content.copyRight && this.renderCopyRight(copyRightReservedText),
                this.renderLinks(tertiaryLinks)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              showImages && footNoteLogo && footNoteLogo.imageUrl && this.renderLogo(footNoteLogo.imageUrl, 'footnote'),
              this.renderFooterNotes(footerNotes)
            )
          )
        )
      );
    }
  }]);

  return MPPFooter;
}(_react2.default.Component);

exports.default = MPPFooter;


var LinkPropType = _propTypes2.default.shape({
  list: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    href: _propTypes2.default.string,
    target: _propTypes2.default.string,
    countryCode: _propTypes2.default.bool
  }))
});

MPPFooter.propTypes = {
  content: _propTypes2.default.shape({
    country: _propTypes2.default.shape({
      locales: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _propTypes2.default.string,
        href: _propTypes2.default.string
      })),
      flag: _propTypes2.default.shape({
        text: _propTypes2.default.string,
        href: _propTypes2.default.string
      })
    }),
    mainLinks: _propTypes2.default.shape({
      list: _propTypes2.default.arrayOf(LinkPropType)
    }),
    secondaryLinks: _propTypes2.default.shape({
      list: _propTypes2.default.arrayOf(LinkPropType)
    }),
    secondaryLogo: _propTypes2.default.shape({
      imageUrl: _propTypes2.default.string.isRequired
    }),
    tertiaryLinks: _propTypes2.default.shape({
      list: _propTypes2.default.arrayOf(LinkPropType)
    }),
    copyRight: _propTypes2.default.shape({
      reservedText: _propTypes2.default.string
    }),
    footNoteLogo: _propTypes2.default.shape({
      imageUrl: _propTypes2.default.string.isRequired
    }),
    footerNotes: _propTypes2.default.shape({
      text: _propTypes2.default.string
    })
  }),
  flagHref: _propTypes2.default.string,
  localeCountry: _propTypes2.default.string,
  loggedIn: _propTypes2.default.bool,
  rtl: _propTypes2.default.bool
};

MPPFooter.defaultProps = {
  content: {
    country: {
      locales: [{
        text: 'English',
        href: '?locale.x=en_US'
      }],
      flag: {
        text: 'See all countries',
        href: '/webapps/mpp/country-worldwide'
      }
    },
    mainLinks: {
      list: [{
        text: 'Help',
        href: '/smarthelp/home'
      }, {
        text: 'Contact',
        href: '/smarthelp/contact-us'
      }, {
        text: 'Fees',
        href: '/webapps/mpp/paypal-fees'
      }, {
        text: 'Security',
        href: '/webapps/mpp/paypal-safety-and-security'
      }, {
        text: 'Apps',
        href: '/webapps/mpp/mobile-apps'
      }, {
        text: 'Shop',
        href: '/webapps/mpp/shopping-selection'
      }]
    },
    secondaryLinks: {
      list: [{
        text: 'About',
        href: '/webapps/mpp/about',
        target: '_blank'
      }, {
        text: 'Blog',
        href: '/stories/us',
        target: '_blank',
        countryCode: false
      }, {
        text: 'Jobs',
        href: '/webapps/mpp/jobs',
        target: '_blank'
      }, {
        text: 'Investor Relations',
        href: 'https://investor.paypal-corp.com'
      }, {
        text: 'Social Innovation',
        href: '/webapps/mpp/social-innovation'
      }, {
        text: 'Public Policy',
        href: 'https://publicpolicy.paypal-corp.com'
      }, {
        text: 'Sitemap',
        href: '/webapps/mpp/full-sitemap'
      }, {
        text: 'Enterprise',
        href: '/webapps/mpp/enterprise'
      }, {
        text: 'Partners',
        href: '/webapps/mpp/partner-program'
      }]
    },
    copyRight: {},
    tertiaryLinks: {
      list: [{
        text: 'Privacy',
        href: '/webapps/mpp/ua/privacy-full'
      }, {
        text: 'Legal',
        href: '/webapps/mpp/ua/legalhub-full'
      }, {
        text: 'Feedback',
        href: '#',
        id: 'siteFeedback'
      }]
    },
    footerNotes: {
      text: 'Consumer advisory - PayPal Pte. Ltd., Users are advised to read the ' + '<a href="/webapps/mpp/ua/legalhub-full">terms and conditions</a> carefully.'
    }
  },
  localeCountry: 'US',
  loggedIn: false,
  flagHref: '/webapps/mpp/country-worldwide',
  rtl: false
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/footer/jsx/MPPFooter.js
// module id = 676
// module chunks = 4